import React from "react";
import { Link } from "react-router-dom";
import { Trash2 } from "react-feather";

const TourSummaryProductsRow = ({ token, tourId, product, units, recipientNames, userIsEditor }) => {

  const deletePath = "/delete/tour/" + tourId + "/product/" + product._id; 

  const iconSize = 20;

  return (
    <tr>
      <td>{product.name}</td>
      <td>{units}</td>
      <td className="right">{product.price / 100}</td>
      {
        recipientNames.length > 0 && recipientNames.map((recipientName, index) => {
          let recipient = { split: "loading...", type: "loading..." };
          if (product.recipients.length > 0) {
            recipient = product.recipients.find(recipient => recipient.recipientName === recipientName);
          }
          /* 
          The above conditional block might result in recipient being null, which will cause the
          following conditional block to fail - a null value can't have a .type property.
          This will happen where somebody who is a recipient in relation to at least one product on the tour
          is not included in the recipients array for this particular product.
          The next line ensures that recipient doesn't have a null value in those circumstances and just
          shows 0% in the table.
          */
          recipient = recipient || { type: "residue", split: 0};
          if (recipient.type === "residue") {
            return (
              <td className="right hideLtTablet" key={index}>{recipient.split}%</td>
            )
          }
          return (
            <td className="right hideLtTablet" key={index}>£{recipient.split/100}</td>
          )
        })
      }
      {
        userIsEditor &&
        (
          <td><Link to={deletePath} className="icon-button-link-warning"><Trash2 size={iconSize} /></Link></td>
        )
      }
    </tr>
  )
};

export default TourSummaryProductsRow;